/**
 * Creates a keyboard event handler for accessible interactive elements.
 * Triggers the callback when Enter.
 *
 * @param callback - Function to execute on valid key press
 * @param options - Configuration options
 * @param options.disabled - When true, prevents callback execution
 * @param options.preventDefault - When true, prevents default browser behavior (default: true)
 * @param options.triggerOnSpace - When true, replicates the effect of pressing "Enter" (default: true)
 * @returns Keyboard event handler
 */

import { TKeyboardInteractionOptions } from "./types";

export const handleEnterKeyInteraction = (
  callback: () => void,
  options: TKeyboardInteractionOptions = {}
): React.KeyboardEventHandler => {
  const { disabled = false, preventDefault = true, triggerOnSpace = true } = options;

  return (e) => {
    if (e.key === 'Enter' || (e.key === ' ' && triggerOnSpace)) {
      if (preventDefault) {
        e.preventDefault();
      }

      if (!disabled) {
        callback();
      }
    }
  };
};